import { Avatar, Text } from "@fluentui/react-components";
import {
	AcceptInteractionButton,
	RejectInteractionButton,
} from "@/components/atoms/interactionButtons";
import { useStyles } from "./style";
import { InteractionActionCardProps } from "./types";
import { Flex } from "@/components/atoms/flex";

export const InteractionActionCard = (props: InteractionActionCardProps) => {
	const { contactName, icon, message, acceptInteraction, rejectInteraction } =
		props;
	const style = useStyles();

	return (
		<div className={style.cardContainer}>
			<Flex column vAlign="center" className={style.innerContainer}>
				<Text
					align="center"
					weight="bold"
					block
					truncate
					wrap={false}
					title={contactName}
					className={style.contactName}
				>
					{contactName}
				</Text>
				<div className={style.icon}>{icon}</div>
				<Text
					align="center"
					block
					className={style.message}
					truncate
					wrap={false}
					title={message}
				>
					{message}
				</Text>
				<Avatar className={style.avatar} size={48}/>
				<Flex hAlign="space-between" className={style.buttons}>
					<AcceptInteractionButton onClick={acceptInteraction} />
					<RejectInteractionButton onClick={rejectInteraction} />
				</Flex>
			</Flex>
		</div>
	);
};
